export enum BenefitTransactionStatuses {
  Pending = 'Pending',
  ReadyForPayment = 'ReadyForPayment',
  Active = 'Active',
  Completed = 'Completed',
}
